module.exports = __webpack_public_path__ + "Roboto-Thin.954bbdeb86483e4ffea0.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/angular-bootstrap-md/font/roboto/Roboto-Thin.woff2
// module id = 471
// module chunks = 2